module.exports = __webpack_public_path__ + "0700e7ce32ef0f2acb4c6e2bcec7ca88.svg";